import { BtmReturnRequest, IBaseBtmReturnRequestDetailsDto } from "../../model/btm-return-request";
import { BtmReturnInspectionProduct } from "../../model/btm-return-inspection-product";
import { httpPut } from "../../../../../common/network/fetch";

export const SubmitReturnRequestInspectionHandler = async (request: BtmReturnRequest,
                                                           inspection: BtmReturnInspectionProduct[]) => {
    const submitReturnRequestResponse = await httpPut<{ returnRequest: IBaseBtmReturnRequestDetailsDto }>({
        url: `/return-request/${request.id}/inspection`,
        data: {
            items: inspection.map(d => ({
                declarationProductId: d.declarationProductId,
                productId: d.productId,
                barcode: d.barcode,
                productName: d.productName,
                status: d.status?.toString(),
                comment: d.comment,
                files: d.files,
            })),
        },
    }, false);

    return new BtmReturnRequest({
        ...request.toDto(),
        returnRequest: submitReturnRequestResponse.returnRequest,
    });
};
